import React from 'react';
import clx from 'classnames';
import { Layout, BackTop } from 'antd';
const { Content, Sider } = Layout;
import './PageLayout.scss';
import { useThemeConfig } from 'client/components/schema/config/ClientConfigModule';
import { MainMenu } from '../../routes/menu/MainMenu';
import { PageLayoutHeaderBrianza } from './header-brianza/PageLayoutHeaderBrianza';

export const getSiderWidth = () => {
  return pageFixedSizes.siderWidht;
};
export const pageFixedSizes = {
  siderWidht: 0,
  topMenuHeight: 34, // TODO attualmente impostati nei css
  topLogoHeight: 40, // TODO attualmente impostati nei css
  topHeaderHeight: 70 + 20 // 70 logo 20 padding // TODO attualmente impostati nei css
};
export interface PageLayoutProps {
  children: React.ReactNode;
  hasMainMenu?: boolean;
  hasSideMenu?: boolean;
  className?: string;
}

/**
 * Layout principale dell'applicativo.
 */
export function PageLayout(props: PageLayoutProps) {
  const { options } = useThemeConfig();

  return (
    <Layout className={clx('page-layout', props.className)}>
      <PageLayoutHeaderBrianza>
        {props.hasMainMenu && <MainMenu />}
      </PageLayoutHeaderBrianza>
      {props.hasSideMenu ? (
        <Layout>
          <Sider
            width={pageFixedSizes.siderWidht}
            className="page-layout-sider"
          >
            {/* <SideMenuSwitch /> */}
          </Sider>
          <Layout>
            <Content className="page-layout-content">{props.children}</Content>
          </Layout>
        </Layout>
      ) : (
        <Content className="page-layout-content">{props.children}</Content>
      )}
      <BackTop className="page-back-top" visibilityHeight={200} />
    </Layout>
  );
}
